/**
 * Pill — small label/chip used for category, status, and modality tags.
 */
export default function Pill({ tone = 'blue', children, dot = false }) {
  const tones = {
    blue: { background: 'var(--blue-soft)', color: 'var(--blue-ink)' },
    sand: { background: 'var(--sand)', color: 'var(--ink-3)' },
    ink: { background: 'var(--ink)', color: 'var(--cream)' },
    outline: {
      background: 'transparent',
      color: 'var(--ink)',
      boxShadow: 'inset 0 0 0 1px rgba(45,42,38,0.20)',
    },
    success: { background: 'rgba(111,142,107,0.18)', color: '#4F6B4D' },
  };
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontFamily: 'var(--font-body)',
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        padding: '6px 12px',
        borderRadius: 999,
        ...tones[tone],
      }}
    >
      {dot && <span style={{ width: 6, height: 6, borderRadius: 999, background: 'currentColor' }} />}
      {children}
    </span>
  );
}
